import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import { useUpdateDashboardVendor } from 'api/hooks/use-dashboard-vendors'
import { useQueryClient } from 'react-query'

function UpdateVendor({ toggleIncludeExclude, vendor, dashboardId, canEdit = true }) {
  const queryClient = useQueryClient()
  const [toggle, setToggle] = useState(vendor.options)

  const { mutate } = useUpdateDashboardVendor({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries(`dashboards/${dashboardId}`)
      }
    }
  })

  const handleToggle = (newOption) => {
    if (!canEdit) return
    if (newOption === vendor.options) return
    setToggle(newOption)
    toggleIncludeExclude(vendor, newOption)
    if (vendor.dashboard_vendor_id) {
      mutate({
        dashboard_vendor_id: vendor.dashboard_vendor_id,
        options: newOption
      })
    }
  }

  return (
    <ButtonGroup>
      <Button
        size="sm"
        variant={vendor.options === 'include' ? 'primary' : 'light'}
        onClick={() => handleToggle('include')}
        disabled={!canEdit}
      >
        Include
      </Button>
      <Button
        size="sm"
        variant={vendor.options === 'exclude' ? 'primary' : 'light'}
        onClick={() => handleToggle('exclude')}
        disabled={!canEdit}
      >
        Exclude
      </Button>
    </ButtonGroup>
  )
}

export default UpdateVendor
